const purchase = {
  title: "HitPaw ऑनलाइन प्रो",
  subTitle: "सरल और पारदर्शी मूल्य के साथ सही योजना चुनें",
  monthlyUppercase: "मासिक",
  montly: "मासिक",
  free: "मुफ़्त",
  yearlyUppercase: "वार्षिक",
  yearly: "वार्षिक",
  inService: "सेवा में",
  buyBtn: "अभी खरीदें",
  freeTips1: "अधिकतम 20 एमबी की फाइल का समर्थन करता है",
  freeTips2: "प्रति दिन 6 फाइल",
  freeTips3: "सामान्य प्रॉसेसिंग गति",
  freeTips4: "सामान्य डाउनलोड गति",
  freeTips5: "प्रति दिन 1 तस्वीर से बैकग्राउंड हटाएं",
  freeTips52: "प्रति दिन 1 तस्वीर से बैकग्राउंड हटाएं",
  freeTips6: "सभी मुफ़्त टूल का एक्सेस",
  vipTips1: "असीमित फाइल साइज़",
  vipTips2: "प्रति दिन असीमित फाइल",
  vipTips3: "तेज़ डाउनलोड गति",
  vipTips4: "तेज़ प्रॉसेसिंग गति",
  vipTips5: "असीमित",
  vipTips6: "प्रति दिन असीमित छवि बैकग्राउंड हटाएं",
  vipTips7: "सभी टूल और प्रीमियम सुविधाओं का एक्सेस",
  vipTips8: "स्वचालित रूप से नवीनीकृत करें और किसी भी समय रद्द करें।",
  vipTips9: "वीडियो साइज़ और मात्रा के लिए कोई सीमा नहीं",
  vipTips10: "असीमित रूप से इमेज बैकग्राउंड हटाएं",
  vipTips11: "तेज़ वीडियो प्रॉसेसिंग और डाउनलोड स्पीड",
  vipTips12: "सभी मुफ़्त टूल और प्रीमियम सुविधाएं एक्सेस करें",
  acceptTitle: "हम स्वीकार करते है",
  modalTitle: "सभी प्रीमियम सुविधाओं के एक्सेस के लिए प्रो में अपग्रेड करें",
  total: "कुल",
  enterCode: "कोड डालें",
  SignUpToPurchaseBtn: "ख़रीदने के लिए साइन अप करें",
  purchaseBtn: "ख़रीदारी पर जाएं",
  saveTips: "{{num}}% तक बचाएं",
  discount: "छूट",
  purchaseTips: "स्वचालित रूप से नवीनीकृत करें और किसी भी समय रद्द करें।",
  tips: "उपाय:",
  promoCodeInvalidTips: "आपका प्रोमो कोड अमान्य है",
};

export default purchase;
